var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1BACE4",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M12.75,4.5 L16.5,4.5 C17.3284271,4.5 18,5.17157288 18,6 L18,21.75 C18,22.5784271 17.3284271,23.25 16.5,23.25 L1.5,23.25 C0.671572875,23.25 0,22.5784271 0,21.75 L0,6 C0,5.17157288 0.671572875,4.5 1.5,4.5 L5.25,4.5 C5.25,2.42893219 6.92893219,0.75 9,0.75 C11.0710678,0.75 12.75,2.42893219 12.75,4.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.891,
    d: "M10.5776125 13.6857595L1.38019343 13.6857595 5.38658916.864115912C5.46539716.613331306 5.70604055.441722717 5.97890294.441722717 6.25176533.441722717 6.49240873.613331306 6.57121673.864115912L10.5776125 13.6857595zM4.13941914 4.85623725L7.81838675 4.85623725M3.587574 6.6221417L8.37023189 6.6221417M2.75980628 9.27099838L9.1979996 9.27099838M2.20796114 11.0369028L9.74984474 11.0369028M.000580575397 13.6857595L11.9572253 13.6857595",
    transform: "translate(3 7)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M9 3.75C9.20710678 3.75 9.375 3.91789322 9.375 4.125M8.625 4.125C8.625 3.91789322 8.79289322 3.75 9 3.75M9 4.5C8.79289322 4.5 8.625 4.33210678 8.625 4.125M9.375 4.125C9.375 4.33210678 9.20710678 4.5 9 4.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiry);
export default __webpack_public_path__ + "static/media/enquiry.a91fb506bc68959d0a83b60f45ceff73.svg";
export { ForwardRef as ReactComponent };